import axios from 'axios';

const BASE_URL = 'https://bingchongweb-api.d.agriai.cc/api/v1';

// 获取访问统计
export const getVisitStats = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/visit/stats`);
    return response.data;
  } catch (error) {
    console.error('获取访问统计失败:', error);
    throw error;
  }
};

// 获取简化访问统计
export const getSimpleVisitStats = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/visit/stats/simple`);
    return response.data;
  } catch (error) {
    console.error('获取简化访问统计失败:', error);
    throw error;
  }
};

// 获取统计概览
export const getStatsSummary = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/visit/stats/summary`);
    return response.data;
  } catch (error) {
    console.error('获取统计概览失败:', error);
    throw error;
  }
};

// 获取识别记录
export const getRecognitionRecords = async (params = {}) => {
  try {
    const response = await axios.get(`${BASE_URL}/visit/recognition-records`, { params });
    return response.data;
  } catch (error) {
    console.error('获取识别记录失败:', error);
    throw error;
  }
};

// 获取识别统计
export const getRecognitionStats = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/visit/recognition-stats`);
    return response.data;
  } catch (error) {
    console.error('获取识别统计失败:', error);
    throw error;
  }
};